const eventsPending = []
export const initAmplitude = (userID, userProperties, callback) => {
  if (typeof window !== 'undefined') {
    const amplitude = require('amplitude-js');
    const amplitudeClient = amplitude.getInstance()
    amplitudeClient.init(process.env.AMPLITUDE_API_KEY, userID, {}, () => {
      const optOut = !!window.localStorage.getItem('amplitudeOptOut')
      const identify = new amplitude.Identify()

      amplitude.getInstance().setOptOut(optOut);
      userProperties && amplitude.getInstance().setUserProperties(userProperties);

      callback && callback()
    })
  }
}
export const logAmplitudeEvent = (eventName, eventProperties, eventCallback) => {
  if (typeof window !== 'undefined') {
    const amplitude = require('amplitude-js');
    const amplitudeClient = amplitude.getInstance()
    if (amplitudeClient._isInitialized) {
      amplitudeClient.logEvent(eventName, eventProperties, eventCallback)
      if (eventsPending.length > 0) {
        eventsPending.forEach((event, index) => {
          amplitudeClient.logEvent(event[0], event[1])
        })
        eventsPending.length = 0
      }
    } else {
      eventsPending.push([eventName, eventProperties])
    }
  }
}
export const setAmplitudeUserProperties = (userProperties) => {
  if (typeof window !== 'undefined') {
    const amplitude = require('amplitude-js');
    userProperties && amplitude.getInstance().setUserProperties(userProperties);
  }
}
